<template>
  <div style="background: #1f1c1f;">
    <div class="header">
      <div class="header_content">
        <div v-if="!hasToken" @click="toLogin('/Register')">{{ $t('女团.注册') }}</div>
        <div v-else></div>
        <div class="img_c" style="color: #e6b98a;">
          {{ $t('女团.女团') }}
        </div>
        <div class=""></div>
      </div>
    </div>

    <div class="tu_list">
      <div class="tu_item" v-for="item in datalist" :key="item.id" @click="toDetail(item.id)">
        <div class="renzh">{{ $t('女团.身份验证') }}</div>
        <div class="info_box">
          <div class="c_id">{{ item.xuanfei_name }}</div>
          <div class="c_c">{{ $t('女团.身高') }}: {{item.hight}}cm</div>
          <div class="c_c">{{ $t('女团.胸围') }}：{{ item.bust }}</div>
          <div class="c_c">{{ $t('女团.服务城市') }}</div>
          <div class="c_b_k">
            <img src="/img/common/icon-views.png" class="sm_in">
            <span>{{item.chakan}}</span>
            <img src="/img/common/icon-love.png" class="sm_in cc">
            <span>{{item.dianzan}}</span>
          </div>
        </div>
        <img :src="item.img_url" class="sm_in_c van-image__img" style="object-fit: cover;">
      </div>
    </div>

    <div style="padding-bottom: 55px;"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      notice: this.$t('请求.获取中'),
      hasToken: false,
      basicData: [],
      datalist: [],
      groupedData: [],
      banners: [{}],
      tagTypes: ['primary', 'success', 'danger', 'warning']
    };
  },
  methods: {
    getBasicConfig() {
      this.$http({
        method: "get",
        url: "sys_config",
      }).then((res) => {
        this.basicData = res.data;
        this.getNotice(this.basicData);
        this.getBanner(this.basicData);
      });
    },
    getBanner(data) {
      this.banners = data.banners;
    },
    toLogin(str) {
      this.$router.push({ path: str });
    },
    getNotice(data) {
      this.notice = data.notice;
    },
    toDetail(id) {
      this.$router.push({ path: "/detail", query: { id: id } });
    },
    checkToken() {
      const token = localStorage.getItem("token");
      this.hasToken = !!token;
    },
    // ★ 支持地区参数筛选
    getxuanfeilist(area = '') {
      this.$http({
        method: "get",
        url: "xuanfeilist",
        data: { id: 1, page: 1, area: area },
      }).then((res) => {
        const lanng = 'zh';
        this.datalist = res.data;
        this.datalist.forEach(item => {
          if (item.flag) {
            const parts = item.flag.split('|');
            lanng == 'zh' ? item.flag = parts[0]
              : lanng == 'en' ? item.flag = parts[1]
              : lanng == 'ja' ? item.flag = parts[2]
              : item.flag = parts[3];
            item.flagArray = item.flag ? item.flag.split('，') : [];
          } else {
            item.flagArray = [];
          }
        });
        const chunkSize = 2;
        this.groupedData = this.datalist.reduce((acc, item, index) => {
          if (index % chunkSize === 0) acc.push([]);
          acc[Math.floor(index / chunkSize)].push(item);
          return acc;
        }, []);
      });
    },
  },

  // ★ 修复：去掉 scrollContainer 引用避免报错
  mounted() {},

  // ★ 读取地区参数
  created() {
    this.checkToken();
    this.getBasicConfig();
    const area = this.$route.query.area || '';
    this.getxuanfeilist(area);
  },
};
</script>

<style lang="less" scoped>
.tu_list {
  padding-top: 100px;
  .tu_item {
    margin: 26px 20px 16px;
    border-radius: 16px;
    padding: 30px 40px 30px 26px;
    background: linear-gradient(120deg, #212121, #313131);
    border: 1px solid #766350;
    display: flex;
    justify-content: space-between;
    position: relative;
    overflow: hidden;
    .renzh {
      position: absolute;
      right: -58px;
      top: 24px;
      font-size: 24px;
      padding: 2px 48px;
      font-style: normal;
      white-space: nowrap;
      transform: rotate(45deg);
      background: linear-gradient(90deg, #efcba7, #dcab76);
      color: #000000;
    }
    .sm_in_c {
      width: 186px;
      height: 186px;
      border-radius: 50%;
    }
    .info_box {
      .c_id {
        width: 200px;
        text-align: center;
        background: linear-gradient(90deg, #efcba7, #dcab76);
        color: #8d5825;
        border-radius: 40px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .c_c {
        color: #ddd;
        font-size: 26px;
        padding-top: 10px;
      }
      .c_b_k {
        display: flex;
        align-items: center;
        color: #666;
        font-size: 22px;
        padding-top: 16px;
        .sm_in {
          width: 30px;
          height: 30px;
          &.cc {
            margin-left: 16px;
          }
        }
      }
    }
  }
}
.header {
  height: 13vw;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 2;
  background-color: #1f1c1f;
}
.header_content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  margin: 0 40px;
  color: #fff;
}
</style>